import { render, staticRenderFns } from "./MediaSelector.vue?vue&type=template&id=151addfe&scoped=true&"
import script from "./MediaSelector.vue?vue&type=script&lang=js&"
export * from "./MediaSelector.vue?vue&type=script&lang=js&"
import style0 from "./MediaSelector.vue?vue&type=style&index=0&id=151addfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151addfe",
  null
  
)

export default component.exports